import clsx from 'clsx';
import React from 'react';
import classes from './Copyable.module.scss';
import CopyIcon from '../../assets/CopyIcon.svg';

export interface Props {
  value: string;
  className?: string;
  onClick?: () => void;
}

const Copyable: React.FC<Props> = ({ value, className, onClick }) => {
  const [text, setText] = React.useState(value);

  function handleCopy() {
    navigator.clipboard.writeText(value);
    setTimeout(() => {
      setText(value);
    }, 1500);
    setText('Copied to clipboard!');
    onClick && onClick();
  }

  return (
    <button
      type="button"
      className={className ? clsx(classes.root, className) : classes.root}
      onClick={handleCopy}
    >
      <span className={classes.text}>{text}</span>
      <div className={classes.iconContainer}>
        <CopyIcon className={classes.icon} />
      </div>
    </button>
  );
};

export default Copyable;
